import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const { t } = useLang();
  const location = useLocation();
  const navigate = useNavigate();

  const handleHashNav = (e, sectionId) => {
    e.preventDefault();
    if (location.pathname === "/") {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 150);
    }
  };

  return (
    <footer className="bg-burgundy text-white" data-testid="site-footer">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <div className="flex flex-col leading-none">
              <div style={{ display: 'inline-block' }}>
                <span style={{ fontFamily: 'Georgia, serif', letterSpacing: '0.05em', display: 'block' }} className="text-2xl md:text-3xl font-black text-white uppercase">CO<span style={{ marginLeft: '-0.08em' }}>R</span>S<span style={{ marginLeft: '-0.04em' }}>A</span></span>
                <span style={{ fontFamily: 'Arial, sans-serif', letterSpacing: '0.22em', display: 'block', textAlign: 'center' }} className="text-[8px] md:text-[9px] font-normal text-coral uppercase">Exchange</span>
              </div>
            </div>
            <span className="hidden md:inline text-[10px] uppercase tracking-overline text-white/50">
              est. 1995
            </span>
          </div>
          <p className="text-white/70 text-sm max-w-md leading-relaxed font-light">
            {t.footer.tagline}
          </p>
          <p className="mt-4 text-[10px] uppercase tracking-overline text-white/40">
            Corsa International Change Office SRL
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-overline text-coral mb-4">
            {t.footer.links}
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="/#rates" onClick={(e) => handleHashNav(e, "rates")} className="hover:text-coral transition-colors">
                {t.nav.rates}
              </a>
            </li>
            <li>
              <a href="/#about" onClick={(e) => handleHashNav(e, "about")} className="hover:text-coral transition-colors">
                {t.nav.about}
              </a>
            </li>
            <li>
              <Link to="/locatii" className="hover:text-coral transition-colors">
                {t.nav.locations}
              </Link>
            </li>
            <li>
              <Link to="/admin/login" className="hover:text-coral transition-colors text-white/50">
                {t.nav.admin}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] uppercase tracking-overline text-coral mb-4">
            {t.contact.hq}
          </div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-coral" />
              <span>Str. Poporului Nr. 23, Constanta</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-coral" />
              <span className="font-mono-num">0241.693.219</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-coral" />
              <span className="font-mono-num">0722.641.633</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-coral" />
              <a
                href="mailto:office@corsaexchange.ro"
                className="hover:text-coral transition-colors"
              >
                office@corsaexchange.ro
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-5 text-xs text-white/50 flex items-center justify-center">
          <span>© {new Date().getFullYear()} Corsa Exchange · {t.footer.legal}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
